<template>
    <div>
        <el-alert
            v-if="error"
            title=""
            type="error"
            style="margin-bottom: 18px;"
        >
            <span v-if="error">{{ error }}</span>
        </el-alert>
        <el-form
            ref="LoginForm"
            :model="getCorrectCredentialsObject"
            :rules="validationRules"
            label-position="top"
            status-icon
            novalidate
            label-width="120px"
            class="demo-ruleForm"
            @submit="submitLoginForm"
            @keyup.enter.native="submitLoginForm"
        >
            <el-form-item v-if="ldap" :label="getVerbose('auth_field_username')" prop="username">
                <el-input
                    v-model="ldapCredentials.username"
                    type="text"
                    auto-complete="off"
                >
                </el-input>
            </el-form-item>
            <el-form-item
                v-else
                :label="getVerbose('auth_field_email')"
                prop="email"
            >
                <el-input
                    v-model="credentials.email"
                    type="email"
                    auto-complete="off"
                >
                </el-input>
            </el-form-item>

            <el-form-item prop="password">
                <label class="message">
                    {{ getVerbose('auth_field_password') }}
                    <i class="ti-eye" :class="passwordFieldType" @click="switchPasswordInputType"></i>
                </label>
                <el-input
                    v-if="ldap"
                    v-model="ldapCredentials.password"
                    :type="passwordFieldType"
                    auto-complete="off"
                >
                </el-input>
                <el-input
                    v-else
                    v-model="credentials.password"
                    :type="passwordFieldType"
                    auto-complete="off"
                >
                </el-input>
            </el-form-item>
            <el-form-item>
                <button
                    type="submit"
                    class="el-button el-button--primary"
                    @click="submitLoginForm"
                >

                    <i
                        v-if="connecting"
                        class="el-icon-loading"
                    ></i>
                    <span>{{ getVerbose('auth_login_button') }}</span>
                </button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import validator from 'email-validator';
import HttpErrorManager from '../partials/http-error-manager.js';
import {mapGetters} from 'vuex';
export default {
    props:{
        ldap: {
            type: Boolean,
            default: false
        },
        onSuccess: {
            type: Function,
            default(){
                return () => {

                };
            },
            required: false,
        },
    },
    data () {
        return {
            passwordFieldType: 'password',
            credentials: {
                email: '',
                password: ''
            },
            ldapCredentials: {
                username: '',
                password: ''
            },
            error: '',
            connecting: false,
            passwordRules: [
                {
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error(this.getVerbose('login_please_fill_password')));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
            emailRules: [
                {


                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error(this.getVerbose('login_please_fill_email')));
                        } else if(!validator.validate(value)){
                            callback(new Error(this.getVerbose('login_email_incorrect')));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
            usernameRules: [
                {
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error(this.getVerbose('login_please_fill_username')));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'getVerbose',
        ]),
        getCorrectCredentialsObject() {
            return this.ldap ? this.ldapCredentials : this.credentials;
        },
        validationRules() {
            if (this.ldap) {
                return {
                    username: this.usernameRules,
                    password: this.passwordRules
                };
            }
            return {
                email: this.emailRules,
                password: this.passwordRules
            };
        }
    },

    created(){
        this.credentials.email = this.$store.state.api.auth.user.email;
        this.httpErrorManager = new HttpErrorManager();
    },
    methods: {
        switchPasswordInputType(){
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        },
        submitLoginForm(event) {
            event.preventDefault();
            this.$refs.LoginForm.validate().then(() => {
                this.error = '';
                this.connecting = true;

                this.$store.dispatch(
                    this.ldap ? 'loginLDAPUser' : 'loginUser',
                    this.ldap ? this.ldapCredentials : this.credentials
                ).then((response) => {
                    this.onSuccess(response);
                    this.$emit('success', response);
                }).catch((error) => {
                    if(this.isPasswordExpired(error)){
                        console.debug('PASSWORD EXPIRED');
                        this.$emit('on-password-expired', error);
                    }
                    else{
                        try {
                            this.error = this.httpErrorManager.getMessage(
                                error.status, error.data._errors);
                        }
                        catch(error) {
                            console.error(error);
                            this.error = 'Unknow error, please contact an administrator.';
                        }
                    }
                }).finally(() => {
                    this.connecting = false;
                });
            });
        },
        isPasswordExpired(response){
            let passwordExpired = (
                response &&
                response.status === 403 &&
                response.data._errors !== undefined &&
                this.httpErrorManager.getFirstCode(response.data._errors) == 'EXPIRED_PASSWORD'

            );
            return passwordExpired;
        }
    }
};
</script>

<style lang="scss">
.ti-eye.text{
    position: relative;
}
.ti-eye.text:after{
    position: absolute;
    content: "/";
    color: black;
    font-size: 1.8em;
    left: 5px;
    top: -8px;
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/auth/Login.vue